/******************************************************************************
 * Created Date: Tuesday Febuary 15th 2022                                    *
 * Author: Jan A.                                                             *
 * -----                                                                      *
 * Last Modified: Tue Feb 15 2022                                             *
 * Modified By: Jan A.                                                        *
 * -----                                                                      *
 * File: /src/components/account/Users/Utils.js                               *
 * Copyright (c) 2021 Kuva                                                    *
 ******************************************************************************/

function escapeRegExp(value) {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}

const snackBar = (
  enqueueSnackbar,
  msg,
  variant = "success",
  vertical = "top",
  horizontal = "center"
) =>
  enqueueSnackbar(msg, {
    variant: variant,
    anchorOrigin: {
      vertical: vertical,
      horizontal: horizontal
    }
  });

export { escapeRegExp, snackBar };
